<script>
    import {clean} from "../Utilities/Cleaner.svelte";

    export let value;
</script>

<div class="svg">
    {@html clean(value)}
</div>

<style>
    .svg :global(*) {
        height: 100px;
        width: 100px;
    }
</style>